import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { Menu, MenuItem, Dropdown, Radio } from 'components-antd';
import { ArrowDown, Check } from 'components/Icons';
import { showingsFilters } from 'settings/constants/showings';

import styles from './styles.module.scss';
import {
  getShowingAggregateFilterSelector,
  getShowingIsArchiveSelector,
} from 'store/selectors/showingAggregate';
import {
  getShowingAggregateByUserIdEffect,
  setShowingsFilterEffect,
  setShowingsIsArchiveEffect,
} from 'store/effects/showingAggregate';

import { getUserId } from 'store/selectors/user';
import { useLocation } from 'react-router-dom';
import { LocationService } from 'services';
import { AppointmentFilterStatuses, AppointmentStatus } from 'types';
import { dropdownFields, getFilterIcon } from './helper';
import { Icons } from 'pages/Workshop/Icons';

export const ShowingsFilter = (props) => {
  const userId = useSelector(getUserId);

  const [value, setValue] = useState(showingsFilters.allShowings);
  const dispatch = useDispatch();
  const { isArchive } = useSelector(getShowingIsArchiveSelector);
  const { aggregateFilters } = useSelector(getShowingAggregateFilterSelector);

  const locationSrv = new LocationService();
  const location = useLocation();
  locationSrv.setLocation(location);
  const query = locationSrv.getQuery();
  const [queryRender, setQueryRender] = useState<boolean>(true);

  const [ArchiveFilters, setArchiveFilters] = useState([
    AppointmentStatus.Declined,
    AppointmentStatus.Canceled,
    AppointmentStatus.Past,
  ]);

  useEffect(() => {
    // Reset Filters whenever archive button is clicked.
    if (!queryRender) {
      setValue(showingsFilters.allShowings);
      dispatch(setShowingsFilterEffect(showingsFilters.allShowings));
    }
    queryRender && ArchiveFilters.includes(query.status) && !isArchive
      ? setQueryRender(true)
      : setQueryRender(false);
  }, [isArchive]);

  useEffect(() => {
    // Handle dashboard redirect
    let filterStatus = showingsFilters.allShowings;
    if ('teamStats' in query) {
      filterStatus = query.teamStats ? showingsFilters.allShowings : showingsFilters.myShowings;
    }

    dispatch(setShowingsFilterEffect(filterStatus));
    setValue(filterStatus);
  }, []);

  const prepareFilters = (showingValue) => {
    const statusFilters = Object.values(AppointmentFilterStatuses);

    if (showingValue === showingsFilters.allShowings) {
      delete aggregateFilters.isMyShowing;
    } else {
      aggregateFilters.isMyShowing = true;
    }

    return { Status: statusFilters, ...aggregateFilters };
  };

  const onChange = (e) => {
    const val = e.target.value;

    dispatch(setShowingsIsArchiveEffect(false));
    dispatch(
      getShowingAggregateByUserIdEffect({
        id: userId,
        filters: prepareFilters(val),
      }),
    );

    dispatch(setShowingsFilterEffect(val));
    setValue(val);
  };

  const menu = (
    <Radio.Group
      onChange={onChange}
      value={value}
      className={styles.optionsItems}
      defaultValue={value}
    >
      <Menu>
        {dropdownFields.map((item, idx) => (
          <MenuItem key={idx}>
            <Radio value={item.itemValue} key={idx}>
              <div className={styles.option}>
                <span className={styles.optionValue}>{item.itemValue}</span>
              </div>
              {value === item.itemValue && <Check className={styles.checkIcon} />}
            </Radio>
          </MenuItem>
        ))}
      </Menu>
    </Radio.Group>
  );

  return (
    <div className={classNames(styles.filterWrap, props.className)}>
      <Dropdown
        overlay={menu}
        placement="bottomLeft"
        getPopupContainer={(triggerNode) => triggerNode}
        trigger={['click']}
        overlayClassName={styles.teamFilterDropdown}
      >
        <a
          onClick={(e) => e.preventDefault()}
          className={classNames(styles.filterButton, 'mosaikDropdownButton')}
        >
          <Icons variant={getFilterIcon(value)} className={styles.optionIcon} />
          <ArrowDown className={classNames(styles.icon, { [styles.open]: open })} />
        </a>
      </Dropdown>
    </div>
  );
};
